import React, { useEffect, useState, useRef } from 'react';

import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import Input from '../Input/Input';

import "./DateInput.scss"

import { dateToDDMMYYYY, dateFromDDMMYYYY } from '../../../helpers/datetime';

const DateInput = ({ inputHandler, defaultValue = null }) => {
	const dropdown = useRef()
	const [open, setOpen] = useState(false);
	const [value, setValue] = useState(new Date());
	const [valueStr, setValueStr] = useState('');

	useEffect(() => {
		if(defaultValue){
			if(defaultValue.date_formated){
				setValueStr(defaultValue.date_formated)
				setValue(dateFromDDMMYYYY(defaultValue.date_formated))
			}
		}
	}, [defaultValue])

	const onChange = (value, event) => {
		setOpen(false)
		setValue(value)
		setValueStr(dateToDDMMYYYY(value))

		if(inputHandler){
			inputHandler(dateToDDMMYYYY(value))
		}
	}

	const onDateInput = (value) => {
		setValueStr(value)

		if(value.length === 10){
			setValue(dateFromDDMMYYYY(value))
			if(inputHandler){
				inputHandler(value)
			}
		}
	}

	useEffect(() => {
		setTimeout(() => {
			document.addEventListener('click', documentClickHandler);
		},[0])

		return () => document.removeEventListener('click', documentClickHandler);
	}, []);

	const documentClickHandler = (e) => {
		if(!dropdown.current) return;
		if(!dropdown.current.contains(e.target)){
			setOpen(false)
		}
	};

	return (
		<div className={"date-input" + (open ? " open" : '')} ref={dropdown}>
			<button className="date-input__btn" onClick={() => setOpen(!open)}>
				{(!defaultValue || (defaultValue && valueStr !== '')) &&
					<Input defaultValue={valueStr} label='Дата' inputHandler={onDateInput} type={'date'}/>
				}
			</button>
			<div className="date-input__dropdown">
				<Calendar
					onChange={onChange}
					value={value}
					className={'date-input__calendar'}/>
			</div>
		</div>
	);
};

export default DateInput;
